export const STORAGE_ICON_URL = "https://opulant-storage.s3.us-east-1.amazonaws.com/icons";
export const STORAGE_IMAGE_URL = "https://opulant-storage.s3.us-east-1.amazonaws.com/images";
export const STORAGE_GENERIC_URL = 'https://opulant-storage.s3.us-east-1.amazonaws.com'